import { ReCaptchaHidden } from '../../../utilities/ReCaptchaForForms';
import { emailValidation, mobileValidation } from "../../../utilities/validations/inputsValidations"
import { useForm } from 'react-hook-form';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../../hooks/apiFetch';
import { useTranslation } from 'react-i18next';

export default function ContactUsForm({ setErrorMessage, setDataUpdate }) {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const form = useRef();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    async function onSubmit(data) {
        setLoading(true);
        console.log("Form data: ", data); // Debug: Check form data
        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/mailer/contact-us`, {
                method: "POST",
                body: JSON.stringify(data)
            });
            // Redirect to another page after successful submission
            if (response.isSuccess) {
                setDataUpdate(true)
                setTimeout(() => {
                    navigate('/');
                }, 5000);

            } else {
                setErrorMessage(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            setErrorMessage(t("errorGetSupport"));
        } finally {
            setLoading(false);
        }
    }

    return (
        <form id='contactUs-form' className='bg-light-beige-10 rounded shadow d-flex flex-column mx-auto my-4 gap-2 p-4 w-75 w-lg-50'
            ref={form} onSubmit={handleSubmit(onSubmit)}
            method="POST">

            <div className="input-group input-group-sm">
                <span className="input-group-text">{t("Name")}</span>
                <input className={`form-control ${errors.name && "border border-danger"}`}
                    type="text"
                    {...register("name", { required: true, minLength: 10 })} />
                {errors.name && <p className='errors-msg'>{t("errorName")}</p>}
            </div>
            <div className="input-group input-group-sm">
                <span className="input-group-text">{t("Email")}</span>
                <input className={`form-control ${errors.email && "border border-danger"}`}
                    type="email"
                    {...register("email",
                        { required: true, pattern: emailValidation })} />
                {errors.email && <p className='errors-msg'>{t("errorEmail")}</p>}
            </div>
            <div className="input-group input-group-sm">
                <span className="input-group-text" >{t("Phone")}</span>
                <input className='form-control text-start' type="tel" placeholder="05xxxxxxxx"
                    {...register("phone", { required: true, minLength: 10, pattern: mobileValidation })} />
                {errors.phone && <p className='errors-msg'>{t("errorPhone")}</p>}
            </div>
            <div className="input-group input-group-sm">
                <span className="input-group-text">{t("Message")}</span>
                <textarea
                    className={`form-control form-control-sm`}
                    type="text"
                    rows={4}
                    {...register("description")}
                />
            </div>
            <div className="align-self-end">
                <ReCaptchaHidden />
            </div>
            <button className="btn btn-light-beige text-white align-self-end w-auto"
                type='submit'>
                {loading &&
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                }
                {t("Send")}
            </button>
        </form>
    )
}